"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFlag(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm5.47177 15.97791a.61572.61572 0 0 1 -.75573-.46548l-3.19473-12.66735a.66021.66021 0 0 1 .43622-.80286.61512.61512 0 0 1 .75538.46451l3.1936 12.66734a.66185.66185 0 0 1 -.43474.80384zm7.15877-8.08915a6.69438 6.69438 0 0 1 -1.834.18225c-.60181-.00853-1.19671-.05041-1.79938-.05734a6.74319 6.74319 0 0 0 -1.83156.18393 3.595 3.595 0 0 0 -1.871 1.15633c-.22644-.89736-.41478-1.64593-.5916-2.34475-.17727-.6976-.33923-1.34568-.51555-2.04355-.1752-.6985-.36519-1.44579-.59074-2.34315a3.59907 3.59907 0 0 1 1.8709-1.15731 6.64454 6.64454 0 0 1 1.83365-.18038c.60094.00667 1.19584.04721 1.79791.05352a6.608 6.608 0 0 0 1.83283-.18131 3.60578 3.60578 0 0 0 1.87123-1.157c.2265.89763.41623 1.64493.59169 2.34342.17485.69858.33949 1.34693.51581 2.04391.17485.69973.36459 1.4465.58927 2.346a3.61642 3.61642 0 0 1 -1.86946 1.15543z', fillRule: 'evenodd' })));
}
exports.default = SvgFlag;
